export const getRemarkType = (type = '') => {
  if (!type) return 'remarks';
  const remarkType = `${type.toLowerCase()}_remarks`;
  const parsedType = type?.toLowerCase();

  if (parsedType === 'testdrive') {
    return 'test_drive_remarks';
  }
  if (parsedType == 'spotrepair') {
    return 'spot_repair_remarks';
  }

  if (parsedType === 'eindinspectie') {
    return 'final_inspection_remarks';
  }

  if (parsedType == 'exterior_polish') {
    return 'polish_exterior_remarks';
  }

  if (parsedType == 'attach_plates') {
    return 'attach_replate_remarks';
  }
  if (parsedType == 'inspection') {
    return 'final_inspection_remarks';
  }
  if (parsedType == 'testdrive') {
    return 'polish_exterior_remarks';
  }
  if (parsedType == 'reparatie') {
    return 'repair_remarks';
  }

  if (parsedType == 'apk_uitvoeren') {
    return 'apk_remarks';
  }

  if (parsedType == 'final_inspection') {
    return 'final_inspection_remarks';
  }

  if (parsedType == 'terugroepactie') {
    return 'recall_remarks';
  }

  return remarkType;
};
